import { FOLLOW_UPS_MODEL_URL } from 'constants/ApiConstants';
import * as types from 'modules/followUp/actionTypes';

export const getFollowUpModelRequest = (params, meta = {}) => ({
  type: types.GET_FOLLOW_UP_MODEL_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: FOLLOW_UPS_MODEL_URL,
      params,
    },
  },
  meta,
});

export const getFollowUpModelSuccess = (followUpModel, meta = {}) => ({
  type: types.GET_FOLLOW_UP_MODEL_SUCCESS,
  payload: followUpModel,
  meta,
});

export const getFollowUpModelFailure = (error, meta = {}) => ({
  type: types.GET_FOLLOW_UP_MODEL_FAILURE,
  payload: error,
  meta,
  error: true,
});
